import React, { PureComponent } from 'react';

import FieldDefault from './field-default';

export default class Radio extends PureComponent {
    state = {
        other: ''
    }

    handleClick = () => {
        if (this.props.disabled || this.checked) {
            return;
        }

        this.select();
    }

    handleChange = event => {
        this.select();
    }

    handleTextChange = value => {
        this.setState({
            other: value
        });

        this.props.onChange && this.props.onChange(value);
    }

    select() {
        this.props.onChange && this.props.onChange(this.props.value);
    }

    get checked() {
        if (this.props.other) {
            return this.props.selected === this.state.other || this.props.selected === this.props.value;
        }

        return this.props.selected === this.props.value;
    }

    componentDidUpdate() {
        if (this.checked && this.fieldCtrl) {
            setTimeout(() => {
                this.fieldCtrl.focus();
            }, 50);
        }
    }

    render() {
        return (
            <div className={'radio-holder' + (this.checked ? ' checked' : '')} onClick={this.handleClick}>
                <span className={'radio' + (this.checked ? ' checked' : '') + (this.props.disabled ? ' disabled' : '')}>
                    {
                        this.props.id ? <input type="radio" id={this.props.id} disabled={this.props.disabled} checked={this.checked} onChange={this.handleChange} /> : null
                    }
                </span>

                <div className="radio-label">
                    { this.props.label }

                    {
                        this.props.other ? (
                            <FieldDefault small={true} provideController={ctrl => this.fieldCtrl = ctrl} onChange={this.handleTextChange} value={this.state.other} />
                        ) : null
                    }
                </div>
            </div>
        );
    }
}
